export default __webpack_public_path__ + "static/image3-0298ce4503c32dff2190402f02e7e126.jpg";